import { render, staticRenderFns } from "./messageBoard.vue?vue&type=template&id=495c2eb9&scoped=true"
import script from "./messageBoard.vue?vue&type=script&lang=js"
export * from "./messageBoard.vue?vue&type=script&lang=js"
import style0 from "./messageBoard.vue?vue&type=style&index=0&id=495c2eb9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495c2eb9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('495c2eb9')) {
      api.createRecord('495c2eb9', component.options)
    } else {
      api.reload('495c2eb9', component.options)
    }
    module.hot.accept("./messageBoard.vue?vue&type=template&id=495c2eb9&scoped=true", function () {
      api.rerender('495c2eb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/exchange/messageBoard.vue"
export default component.exports